module.exports = __webpack_public_path__ + "static/media/twitter.83692b23.svg";